import React from 'react';
import './LoadingSkeleton.css';

type BlockProps = { className?: string; style?: React.CSSProperties };

export function SkeletonBlock({ className, style }: BlockProps) {
  return <div className={`vipmp-skeleton-block ${className || ''}`.trim()} style={style} aria-hidden />;
}

export function TableSkeleton({ rows = 6, cols = 6 }: { rows?: number; cols?: number }) {
  return (
    <div className="vipmp-table-skeleton" role="status" aria-label="Loading table">
      <div className="vipmp-skeleton-table-row vipmp-skeleton-header">
        {Array.from({ length: cols }).map((_, c) => (
          <SkeletonBlock key={c} className="vipmp-skeleton-cell" style={{ width: '100%' }} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="vipmp-skeleton-table-row">
          {Array.from({ length: cols }).map((_, c) => (
            <SkeletonBlock key={c} className="vipmp-skeleton-cell" style={{ width: c === 0 ? '40%' : '80%' }} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function KpiRowSkeleton() {
  return (
    <div className="om-analytics-kpis" style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }} aria-hidden>
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="om-analytics-kpi" style={{ minWidth: 120 }}>
          <SkeletonBlock style={{ height: 10, width: 80, marginBottom: 8 }} />
          <SkeletonBlock style={{ height: 24, width: 100 }} />
        </div>
      ))}
    </div>
  );
}

export function ChartGridSkeleton({ n = 4 }: { n?: number }) {
  return (
    <div className="om-analytics-charts-grid" aria-hidden>
      {Array.from({ length: n }).map((_, i) => (
        <div key={i} className="om-analytics-chart-card" style={{ padding: 16 }}>
          <SkeletonBlock style={{ height: 16, width: '50%', marginBottom: 12 }} />
          <SkeletonBlock style={{ height: 220, width: '100%' }} />
        </div>
      ))}
    </div>
  );
}

export function PageLoadingOverlay({ message = 'Loading…' }: { message?: string }) {
  return (
    <div className="vipmp-page-loading" role="status" aria-live="polite" aria-label={message}>
      <div className="vipmp-page-loading-spinner" />
      <p className="vipmp-page-loading-text">{message}</p>
    </div>
  );
}
